"use client";

import { motion } from "framer-motion";

export const FloatingFabricBackground = () => {

  return (
    <div className="fixed inset-0 overflow-hidden z-[-1]">
      <motion.div
        className="absolute inset-0 w-full h-full"
        style={{
          backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='100' height='100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M 100 0 L 0 0 0 100' fill='none' stroke='rgba(125, 125, 125, 0.3)' stroke-width='2' stroke-dasharray='4 4'/%3E%3C/svg%3E\")",
          backgroundSize: "100px 100px",
        }}
        animate={{
          backgroundPosition: ["0px 0px", "-100px 0px"],
        }}
        transition={{
          ease: "linear",
          duration: 15,
          repeat: Infinity,
          repeatType: "loop",
        }}
      />
    </div>
  );
};